import { Amplify } from 'aws-amplify';
import config from './utils/config.js';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App.js';
import * as serviceWorker from './serviceWorker';
import { BrowserRouter as Router } from 'react-router-dom';
import { Constants } from './utils/helpers';

const OPEN = 'public';

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId:        config.cognito.USER_POOL_ID,
      userPoolClientId:  config.cognito.APP_CLIENT_ID,   // v6 key (was userPoolWebClientId)
      identityPoolId:    config.cognito.IDENTITY_POOL_ID,
      // v6 replacement for mandatorySignIn semantics:
      // false => do NOT grant guest (unauth) credentials
      allowGuestAccess:  false
    }
  },
  API: {
    // v6 REST config shape: API.REST.<apiName> = { endpoint, region, ... }
    REST: {
      [OPEN]: {
        endpoint: config.apiGateway.URL,
        region:   config.apiGateway.REGION
      },
      [Constants.API_PATH]: {
        endpoint: `${config.apiGateway.URL}/${Constants.API_PATH}`,
        region:   config.apiGateway.REGION
      }
    }
  }
});

ReactDOM.render(
  <Router>
    <App />
  </Router>,
  document.getElementById('root')
);

serviceWorker.unregister();
